import React from "react"
import { Text, Heading, Flex, Link, Box } from "@chakra-ui/react"
import { Link as GatsbyLink } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BlickeReiterSvg } from "../layout/svgs"
import CategorySVGSwitch from "../../config/svgs"

const BereichePage = ({ data }) => {
  const { title, uri } = data

  const kategorie = data.pagebuilder.fixeElementeTop.kategorie

  return (
    <Flex align="center" direction="column" px={4} mb={20}>
      {kategorie[0] && (
        <Box w="70px" h="70px" mb={4}>
          {CategorySVGSwitch(kategorie[0])}
        </Box>
      )}

      <Heading
        as="h3"
        fontFamily="CocoSharp-Bold"
        fontSize="1.875rem"
        lineHeight="1.875rem"
        textAlign="center"
        mb={1}
      >
        {title}
      </Heading>
      <Text
        textAlign="center"
        overflow="hidden"
        dangerouslySetInnerHTML={{
          __html:
            data.pagebuilder.fixeElementeTop.teaserText &&
            data.pagebuilder.fixeElementeTop.teaserText,
        }}
      />
      <Link
        as={GatsbyLink}
        to={uri}
        mt={6}
        color="dark_blue"
        aria-label={`Weitere Infos zu "${title}"`}
      >
        <ArrowForward />
        weitere Infos
      </Link>
    </Flex>
  )
}

const BlickePage = ({ data }) => {
  const image = getImage(
    data.pagebuilder.fixeElementeTop.teaserBild?.bild?.localFile
  )
  const { title, uri } = data
  return (
    <Flex
      align="center"
      direction="column"
      borderColor="dark_blue"
      borderWidth="1px"
      position="relative"
      pt={8}
      mb={24}
    >
      <Heading
        as="h3"
        px={4}
        fontFamily="kepler-std"
        fontSize="1.875rem"
        lineHeight="1.875rem"
        fontWeight="semibold"
        textAlign="center"
      >
        {title}
      </Heading>
      <div
        style={{
          width: "15px",
          margin: "1rem auto",
          borderBottom: "1px solid black",
        }}
      />
      <Text
        textAlign="center"
        mb={6}
        px={4}
        overflow="hidden"
        dangerouslySetInnerHTML={{
          __html:
            data.pagebuilder.fixeElementeTop.teaserText &&
            data.pagebuilder.fixeElementeTop.teaserText,
        }}
      ></Text>
      {data.pagebuilder.fixeElementeTop.teaserBild.bild && (
        <GatsbyImage
          image={image}
          alt={
            data.pagebuilder.fixeElementeTop.teaserBild.bild.altText || title
          }
        />
      )}
      <Box
        width="100px"
        height="32px"
        position="absolute"
        display="flex"
        justifyContent="center"
        alignItems="center"
        top="-32px"
        left="50%"
        transform="auto"
        translateX={"-50%"}
      >
        <BlickeReiterSvg />
      </Box>

      <Link
        to={uri}
        as={GatsbyLink}
        _hover={{ textDecoration: "none" }}
        role="group"
        aria-label={`Hier ist der Link zu "${title}"`}
      >
        <Box
          width="170px"
          height="50px"
          display="flex"
          position="absolute"
          justifyContent="center"
          alignItems="center"
          border="1px"
          borderColor="#212121"
          borderRadius="32px"
          backgroundColor="white"
          _hover={{ backgroundColor: "#E9C542" }}
          mx="auto"
          mt={2}
          bottom="-25px"
          left="50%"
          transform="translateX(-50%)"
        >
          <Text
            fontFamily="CocoSharpL-Bold"
            textAlign="center"
            fontSize="sm"
            letterSpacing="1px"
            fontWeight="bold"
            pt={1}
          >
            ARTIKEL LESEN
          </Text>
        </Box>
      </Link>
    </Flex>
  )
}

const FeaturedArticle = ({ data }) => {
  switch (data.pagebuilder.fixeElementeTop.typ.name) {
    case "Bereiche":
      return <BereichePage data={data} />
    case "Blicke":
      return <BlickePage data={data} />

    default:
      break
  }
  return <div></div>
}

export default FeaturedArticle

export const ArrowForward = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.065"
    height="11.694"
    viewBox="0 0 11.065 11.694"
    style={{ display: "inline", marginRight: "0.5rem" }}
  >
    <g id="Group_2066" data-name="Group 2066" transform="translate(0 0.354)">
      <line
        id="Linie_79"
        data-name="Linie 79"
        x1="10.358"
        transform="translate(0 5.493)"
        fill="none"
        stroke="#002149"
        strokeWidth="1"
      />
      <path
        id="Pfad_1589"
        data-name="Pfad 1589"
        d="M437.646,417.556l5.493,5.493-5.493,5.493"
        transform="translate(-432.781 -417.556)"
        fill="none"
        stroke="#002149"
        strokeWidth="1"
      />
    </g>
  </svg>
)
